export const REACTIONS = {
    LIKE: 'like',
    FUNNY: 'funny',
    SAD: 'sad',
    AMAZE: 'amaze',
    WISH: 'wish',
    LOVE: 'love'
};
